<div class="row  mb-2">
    <div class="col mt-lg-n2">
        <div widget class="card border-0 box-shadow ">
            <div class="rowb card-header transparent text-muted">
                <div class="row">
                    <div class="col">
                        <div class="text-left">
                            <h4 class="mb-0 font-header">Employee Agreement</h4>
                        </div>
                        <div class="" >
                            <button class="btn btn-sm px-3 float-end ms-3" (click)="backToOnboardingList()" *ngIf="employeeBO.edit || employeeBO.print"><i
                                class="fa fa-arrow-left  me-1"></i>Back</button>
                                <button class="btn btn-sm px-3 float-end" (click)="PrintAllDocument()" *ngIf="employeeBO.print">Print All Document</button>
                        </div>
                    </div>
                </div>
            </div>           
        </div>
    </div>
</div>


<div class="row mb-2 d-none">
    <div class="col ">
        <div widget class="card border-0 box-shadow">
            <div class="card-header-top transparent text-muted">
                <div id="stepper1" class="bs-stepper">
                    <div class="bs-stepper-header">
                        <div class="step ml-3" data-target="#test-l-1">
                            <button class="step-trigger" (click)="MoveToNextPage('enrollment')">
                                <i class="bs-stepper-circle fa fa-user-plus" aria-hidden="false" [ngClass]="[PageViewCreateOrEdit.savedpage>0?'saved':Employeepage=='enrollment'?'highlight':'']"></i>
                                <span class="bs-stepper-label "   [ngClass]="[PageViewCreateOrEdit.savedpage>0?'saved':Employeepage=='enrollment'?'highlight':'']"   >Profile</span>
                            </button>
                        </div>
                       
                        <div class="line"></div>
                        <div class="step mr-3" data-target="#test-l-6" *ngIf="employeeBO.addnew" >
                            <button class="step-trigger border-0"  (click)="MoveToNextPage('document')" [disabled]="!PageViewCreateOrEdit.enableDoc" >
                                <i class="bs-stepper-circle fa fa-file " aria-hidden="false" [ngClass]="[PageViewCreateOrEdit.savedpage>5?'saved':Employeepage=='document'?'highlight':'']"></i>
                                <span class="bs-stepper-label" [ngClass]="[PageViewCreateOrEdit.savedpage>5?'saved':Employeepage=='document'?'highlight':'']"  >
                                       Document</span>

                            </button>
                        </div> 
                        <div class="step mr-3" data-target="#test-l-6" *ngIf="!employeeBO.addnew">
                            <button class="step-trigger border-0"  (click)="MoveToNextPage('document')"  >
                                <i class="bs-stepper-circle fa fa-file " aria-hidden="false" [ngClass]="[PageViewCreateOrEdit.savedpage>5?'saved':Employeepage=='document'?'highlight':'']"></i>
                                <span class="bs-stepper-label" [ngClass]="[PageViewCreateOrEdit.savedpage>5?'saved':Employeepage=='document'?'highlight':'']"  >
                                       Document</span>

                            </button>
                        </div> 
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-document (newItemEvent)="dataEmitfromChild($event)" *ngIf="Employeepage=='document'" [emitemployeeBO]="employeeBO" ></app-document>



